import { Spacer } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardCta from 'components/CardCta';
import { Scissors, VideoCamera, WaveIcon } from 'components/icons';
import {
  onOpenTemplateInEditor,
  onOpenTemplateWizard,
} from 'redux/modules/mixpanel';
import { templateSelector } from 'redux/modules/template-wizard/selectors';
import { LandingPageFlowType } from '../types';
import CTAContainer from './CTAContainer';
import TemplateWizardGreeting from './TemplateWizardGreeting';

export type TemplateFlowSelectorProps = {
  onFlowSelect: (flow: LandingPageFlowType) => void;
};

const ICON_WIDTH_PX = 16;

const TemplateFlowSelector: React.FC<TemplateFlowSelectorProps> = ({
  onFlowSelect,
}) => {
  const dispatch = useDispatch();
  const template = useSelector(templateSelector);

  const handleAudioClick = useCallback(() => {
    onFlowSelect('audio');
    dispatch(onOpenTemplateWizard(template.templateId, template.templateType));
  }, [dispatch, onFlowSelect, template?.templateId, template?.templateType]);

  const handleVideoClick = useCallback(() => {
    onFlowSelect('video');
    dispatch(onOpenTemplateWizard(template.templateId, template.templateType));
  }, [dispatch, onFlowSelect, template?.templateId, template?.templateType]);

  const handleAdvancedClick = useCallback(() => {
    onFlowSelect('advanced');
    dispatch(onOpenTemplateInEditor());
  }, [dispatch, onFlowSelect]);

  return (
    <Spacer align="center" justify="center" orientation="vertical" space="12px">
      <TemplateWizardGreeting />
      <Spacer
        align="center"
        space="12px"
        orientation="vertical"
        justify="center"
      >
        <CTAContainer title="quick start">
          <CardCta
            description={<span>Use this template for your audio content.</span>}
            icon={<WaveIcon width={ICON_WIDTH_PX} />}
            label="Add an audio file"
            onClick={handleAudioClick}
            size="small"
            variant="purple"
          />
          <div style={{ display: 'none' }} />
          <CardCta
            description={<span>Use this template for your video content.</span>}
            icon={<VideoCamera width={ICON_WIDTH_PX} />}
            label="Add a video file"
            onClick={handleVideoClick}
            size="small"
            variant="purple"
          />
        </CTAContainer>
        <CTAContainer title="jump right in">
          <CardCta
            description={
              <span>
                Edit captions, add transitions, multiple tracks, watermarks &
                much more.
              </span>
            }
            icon={<Scissors width={ICON_WIDTH_PX} />}
            label="Open in advanced editor"
            onClick={handleAdvancedClick}
            size="small"
            variant="default"
          />
        </CTAContainer>
      </Spacer>
    </Spacer>
  );
};

export default TemplateFlowSelector;
